<template>
  <div>
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      header-class="otp__header_class"
      modal-class="otp__modal_class"
      title-class="otp__title_class"
      title="Verify OTP"
      :ref="refId"
      :id="refId"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
      @hidden="closeDialogBeforeLeave()"
      @hide="closeDialogBeforeLeave()"
      @close="closeDialogBeforeLeave()"
      @cancel="closeDialogBeforeLeave()"
    >
      <!-- no-close-on-esc -->
      <div class="d-flex justify-content-center otp_modal">
        <div class="card p-2 text-center">
          <h6>Please Enter OTP <br /></h6>
          <div>
            <span v-if="resendOtpCount > 0"> Re-Sent to</span>
            <span v-else> Sent to</span>
            <small>{{ customerPhone }}</small>
          </div>
          <div
            id="otp"
            class="inputs d-flex flex-row justify-content-center mt-2"
          >
            <template v-for="(item, i) in OTPArray">
              <input
                :key="i"
                class="m-2 text-center form-control rounded"
                type="text"
                v-model="item.otpValue"
                :id="'input' + (i + 1)"
                v-on:click="inputenter(i + 1)"
                maxlength="1"
              />
              <VkeyboardFloat
                :key="i"
                :ID="'input' + (i + 1)"
                :onClickFun="
                  () => {
                    item.showVKeyboard = !item.showVKeyboard;
                  }
                "
              />
              <Vkeyboard
                :key="i"
                :inputName="'input' + (i + 1)"
                :showOrHide="item.showVKeyboard"
                :initialValue="item.otpValue"
                @onChangeEvent="() => {}"
                @onKeyEnter="validateOtp()"
                @onPressKey="vKeyboardEnter($event, i)"
                @changeKeyboardInput="() => {}"
                @onClickClose="
                  () => {
                    item.showVKeyboard = false;
                  }
                "
              />
            </template>
          </div>
          <div class="mt-4">
            <button class="btn btn-primary px-4 validate" @click="validateOtp">Validate</button>
          </div>
          <div
            class="
              mt-3
              content
              d-flex
              justify-content-center
              align-items-center
            "
          >
            <span>Didn't get the code</span>&nbsp;
            <a class="text-decoration-none ms-3" @click.prevent.stop="resendOtp">Resend</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  props: {
    refId: {
      type: String,
      default: "OTPmodal",
    },
    moduleName: {
      type: String,
      default: "",
    },
    customerPhone: {
      type: String,
      default: "",
    }
  },
  components: {
    VkeyboardFloat,
    Vkeyboard,
  },
  data() {
    return {
      OTPArray: [
        { otpValue: null, showVKeyboard: false },
        { otpValue: null, showVKeyboard: false },
        { otpValue: null, showVKeyboard: false },
        { otpValue: null, showVKeyboard: false },
      ],
      employeeDetails: {
        employee_name: "",
        employee_code: "",
      },
      resendOtpCount: 0,
      keyboardObj: {
        showENameKeyboard: false,
        showECodeKeyboard: false,
      },
      submitted: false,
    };
  },
  computed: {
    ...mapGetters(["getEmployeeDetails"]),
    otpValue() {
      let otpString = ``;
      this.OTPArray.forEach((digit) => {
        otpString += digit["otpValue"] ? String(digit["otpValue"]) : "";
      });
      return otpString;
    },
    inputs() {
      let tempArray = document.querySelectorAll("#otp > *[id]");
      if (tempArray && tempArray.length > 0) {
        return tempArray;
      } else {
        return [];
      }
    },
  },
  mounted() {},
  beforeMount() {},
  methods: {
    ...mapActions(["onSetEmployeeDetails", "onResetEmployeeDetails"]),
    closeDialogBeforeLeave() {},
    _inputenter(id) {
      const inputs = document.querySelectorAll("#otp > *[id]");
      console.log("inputs", inputs);
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("keydown", function (event) {
          console.log("event", event.key);
          if (event.key === "Backspace") {
            inputs[i].value = "";
            if (i !== 0) inputs[i - 1].focus();
          } else {
            if (i === inputs.length - 1 && inputs[i].value !== "") {
              return true;
            } else if (event.keyCode > 47 && event.keyCode < 58) {
              inputs[i].value = event.key;
              if (i !== inputs.length - 1) inputs[i + 1].focus();
              event.preventDefault();
            } else if (event.keyCode > 64 && event.keyCode < 91) {
              inputs[i].value = String.fromCharCode(event.keyCode);
              if (i !== inputs.length - 1) inputs[i + 1].focus();
              event.preventDefault();
            }
          }
        });
      }
    },
    resendOtp() {
        //Write resent OTP API
        this.resendOtpCount++;
        this.$emit("onResendOtp");
    },
    validateOtp() {
        if(!this.otpValue) {
            this.$toasted.show('Please Enter OTP.')
        } else if(this.otpValue.split('').length != this.OTPArray.length) {
            this.$toasted.show('Please Enter Valid OTP.')
        } else {
            this.$emit("onSubmitOtp", this.otpValue);
        }
    },
    vKeyboardEnter(key, i) {
      console.log("id inputenter", key, i);
      let self = this;
      if (key == "{bksp}") {
        if (self.inputs[i].value !== "") {
          self.inputs[i].value = "";
          self.OTPArray[i].otpValue = "";
          if (i !== 0) {
            self.inputs[i].focus();
          }
          console.log(' STILL ABOVE IN IF', self.inputs[i].value);
        } else {
          console.log('EMPTY VALUE COMING TO ELSE');
          self.inputs[i].value = "";
          self.OTPArray[i].otpValue = "";
          if (i !== 0) {
            self.inputs[i - 1].focus();
            self.onClickInputHandler(i - 1);
          }
        }
      } else {
        if (i == (self.inputs.length - 1) && self.inputs[i].value != "") {
          return true;
        } else if (!isNaN(key)) {
          self.inputs[i].value = key;
          self.OTPArray[i].otpValue = key;
          if (i !== self.inputs.length - 1) {
            self.inputs[i + 1].focus();
            self.onClickInputHandler(i + 1);
          }
        } else {
          return true;
        }
      }
    },
    inputenter(id) {
      console.log("id inputenter", id);
      let self = this;
      for (let i = 0; i < this.inputs.length; i++) {
        this.inputs[i].addEventListener("keydown", function (event) {
          if (event.key === "Backspace") {
            if (self.inputs[i].value !== "") {
              self.inputs[i].value = "";
              self.OTPArray[i].otpValue = "";
              if (i !== 0) {
                self.inputs[i].focus();
                self.onClickInputHandler(i);
              }
            } else {
              self.inputs[i].value = "";
              self.OTPArray[i].otpValue = "";
              if (i !== 0) {
                self.inputs[i - 1].focus();
                self.onClickInputHandler(i - 1);
              }
            }
            event.preventDefault();
          } else {
            if (i === self.inputs.length - 1 && self.inputs[i].value !== "") {
              return true;
            } else if (event.keyCode > 47 && event.keyCode < 58) {
              self.inputs[i].value = event.key;
              self.OTPArray[i].otpValue = event.key;
              if (i !== self.inputs.length - 1) {
                self.inputs[i + 1].focus();
                self.onClickInputHandler(i + 1);
              }
              event.preventDefault();
            } else if (event.keyCode > 64 && event.keyCode < 91) {
              return true;
            }
          }
        });
      }
    },
    onClickInputHandler(index) {
      let ifKeyBoardOpen = this.OTPArray.some(
        (keyboard) => keyboard["showVKeyboard"]
      );
      console.log('ifKeyBoardOpen', ifKeyBoardOpen);
      console.log('onClickInputHandler index', index);
      if (ifKeyBoardOpen) {
        this.OTPArray.forEach((otp_digit, otpIndex) => {
          if (index == otpIndex) {
            this.OTPArray[otpIndex]["showVKeyboard"] = !this.OTPArray[otpIndex]["showVKeyboard"];
          } else {
            this.OTPArray[otpIndex]["showVKeyboard"] = false;
          }
        });
      }
      console.log('this.OTPArray', this.OTPArray);
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.otp__title_class {
  font-size: 12px !important;
}

.otp__header_class {
  padding: 0.4rem 1rem !important;
}
.otp_modal .card {
  width: 400px;
  border: none;
  height: 250px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none !important;
}
.otp_modal .card h6 {
  color: #007bff;
  font-size: 20px;
}
.inputs input {
  width: 40px;
  height: 40px;
  border: 1px solid black !important;
}
/* .inputs input:focus {
  box-shadow: none;
  border: 2px solid #007bff !important;
} */

.otp_modal input[type="number"]::-webkit-inner-spin-button,
.otp_modal input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.otp_modal .form-control:focus {
  box-shadow: none;
  border: 2px solid #007bff !important;
}
.otp_modal .validate {
  border-radius: 20px;
  height: 40px;
  background-color: #007bff;
  border: 1px solid #007bff;
  width: 100%;
}
.otp_modal .content a {
  color: #d64f4f;
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/OtpModal.vue